<template>
  <div class="container-fluid">
    <card back>
      <template slot="header">
        <h3>درخواست اضافه کاری</h3>
        <hr />
      </template>
      <template slot="content">
        <requests @DataEdit="RowEdit" :Column="columns" :FormId="2" :rowForEdit="rowForEdit?JSON.parse(rowForEdit):null"></requests>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Requests from '@/components/AutomAtion/Requests.vue'
export default {
  components: { Requests, Card },
  data() {
    return {
      columns: [
        { name: 'noe', label: 'نوع درخواست', visibility: true },
        { name: 'date', label: 'تاریخ', visibility: true },
        { name: 'startTime', label: '  ساعت شروع', visibility: true },
        { name: 'endTime', label: '  ساعت پایان', visibility: true },
        { name: 'dayCount', label: '   تعداد روز', visibility: true },
        { name: 'des', label: 'شرح کار', visibility: true },
        { name: 'filePath', label: 'فایل ضمیمه', visibility: true },
      ],
    }
  },
  props: ['rowForEdit'],
  // mounted(){
  //   console.log("😎 ~ rowForEdit:", JSON.parse(this.rowForEdit))
  // }
  methods:{
    RowEdit(val){
      alert()
    console.log("😎 ~ RowEdit ~ val:", val)

    }
  }
}
</script>
